module.exports = __webpack_public_path__ + "img/bg.c4b30f7.svg";